import SwiperCore, { Navigation, Pagination, Scrollbar, A11y, SwiperOptions } from 'swiper';

SwiperCore.use([Navigation, Pagination, Scrollbar, A11y]);

export function generateSwiperConfigurationHelper(
    spaceBetween: number,
    speed: number,
    isPaginationShown: boolean = true,
    isNavigationShown: boolean = false,
    isLooped: boolean = true): SwiperOptions {

    return {
        direction: 'horizontal',
        spaceBetween: spaceBetween,
        observer: true,
        keyboard: true,
        mousewheel: false,
        loop: isLooped,
        loopFillGroupWithBlank: isLooped,
        speed: speed,
        slidesPerGroup: 1,
        scrollbar: false,
        navigation: isNavigationShown,
        pagination: isPaginationShown ? {
            el: '.swiper-pagination',
            clickable: true,
            bulletClass: 'swiper-pagination-bullet',
        } : false,
        autoplay: {
            delay: 5000,
        }
    };
}
